import React, { Component } from 'react'
import DataInputIcon from '../../images/icon/editInput.svg'
import PaymentIcon from '../../images/icon/paymentIcon.svg'
import FinishIcon from '../../images/icon/finishIcon.svg'
import FinishActive from '../../images/icon/finishActive.svg'
import Check from '../../images/icon/check.svg'
import PaymentActive from '../../images/icon/paymentActive.svg'
import classes from './Status.module.css'
import { withTranslation } from 'react-i18next'
import { strings } from '../../i18n'

class Status extends Component {

    statusObj = () => {
        let screen = this.props
        return ([
            {
                image: screen.screen === 1 ? DataInputIcon : Check,
                text: strings('status.dataInput'),
                dash: true,
                active: screen.screen === 1 ? 1 : false,
                success: screen.screen !== 1 ? 1 : false,
            },
            {
                image: screen.screen === 2 ? PaymentActive : screen.screen === 3 ? Check : PaymentIcon,
                text: strings('status.payment'),
                dash: true,
                active: screen.screen === 2 ? true : 0,
                success: screen.screen === 3 ? 1 : false,
            },
            {
                image: screen.screen === 3 ? FinishActive : FinishIcon,
                text: strings('status.finish'),
                dash: false,
                active: screen.screen === 3 ? true : 0,
                // success: screen.screen === 3 ? true : 0,
            },
        ])
    }

    render () {
        return (
            <div className={classes.status__wrapper}>
                <div className={classes.steps}>
                    <div className={classes.status}>
                        {this.statusObj().map((el, index) => {
                            return (
                                <>
                                    <div className={el.active ? classes.data__input : classes.data__input__not__active}>
                                        <div style={el.active && index !== 2 ? {
                                            height: 38,
                                            marginTop: 14
                                        } : el.active && index === 2 ? { height: 38, marginTop: 12 } : null}
                                             className={el.success ? classes.success : null}>
                                            <img src={el.image} alt={el.text}/>
                                        </div>
                                        <div className={el.active ? classes.text : classes.text__not__active}>
                                            {el.text}
                                        </div>
                                    </div>
                                    {el.dash ?
                                        <div className={classes.line__way} style={el.success ? { borderColor: '#864DD9' } : null}>
                                        </div> : null}
                                </>)
                        })
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(Status)
